<!--
 * @Description: 添加/编辑/详情物料
 * @Author:
 * @Date: 2026-04-29
-->
<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="addVisible"
    :close-on-click-modal="false"
    width="850px"
    v-loading="editDialogLoading"
    :element-loading-background="loadingBackground"
    custom-class="custom-dialog"
    :before-close="closeDialog"
    append-to-body
    v-dialogDrag
  >
    <div class="dialogTitle">
      <div class="line"></div>
      <div class="til">物料基础信息</div>
    </div>
    <el-form
      label-width="110px"
      :model="addForm"
      ref="addForm"
      :rules="addFormRules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="物料编码：" prop="materialNo">
            <remote-search
              v-if="!isEdit && !isDetail"
              v-model="addForm.materialNo"
              :remote="true"
              clearable
              placeholder="物料名称"
              title="物料名称"
              style="width: 220px"
              @change="handleMaterialChange"
            ></remote-search>
            <el-input
              v-else
              v-model="addForm.materialNo"
              placeholder="物料编码"
              title="物料编码"
              disabled
              style="width: 220px"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称：">
            <el-input
              v-model="addForm.materialName"
              placeholder="物料名称"
              title="物料名称"
              disabled
              style="width: 220px"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div>
      <div class="dialogTitle operate-action">
        <div class="line"></div>
        <div class="til">下发参数</div>
        <template v-if="!isDetail">
          <i class="e6-icon-add_line1" title="新增" @click="handleAddParam"></i>
          <i class="e6-icon-delete_line1" title="删除" @click="deleteParams"></i>
        </template>
      </div>
      <el-form ref="tableForm" :model="tableForm" :rules="tableFormRules">
        <el-table
          ref="paramTable"
          highlight-current-row
          @selection-change="handleSelectionChange"
          :data="tableForm.tableData"
          height="300"
          :show-overflow-tooltip="true"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column align="center" min-width="220">
            <template slot="header">
              <span style="color: #f56c6c">*</span>
              <span style="color: #48494c">下发参数</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'tableData.' + scope.$index + '.deviceParam'"
                :rules="tableFormRules.deviceParam"
              >
                <e6-vr-select
                  v-model="scope.row.deviceParam"
                  :data="paramOptions"
                  placeholder="下发参数"
                  title="下发参数"
                  :disabled="isDetail"
                  :props="{
                    id: 'codeId',
                    label: 'codeName'
                  }"
                  @change="handleParamChange(scope.row)"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="220">
            <template slot="header">
              <span style="color: #48494c">参数内容</span>
            </template>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.deviceParamDetail"
                placeholder="参数内容"
                title="参数内容"
                disabled
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>

    <div class="dialog-footer" slot="footer" v-show="!isDetail">
      <el-button class="cancel" @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import base from "@/mixins/base";
import { findDownList, saveMaterialDeviceParam } from "@/api";
import { printError } from "@/utils/util";
export default {
  name: "addMaterialDeviceParam",
  components: {},
  data() {
    return {
      editDialogLoading: false,
      paramOptions: [],
      addForm: {
        materialNo: "",
        materialName: ""
      },
      addFormRules: {
        materialNo: [
          { required: true, message: "请选择物料编码", trigger: "change" }
        ]
      },
      tableForm: {
        tableData: []
      },
      tableFormRules: {
        deviceParam: [
          { required: true, message: "请选择下发参数", trigger: "change" }
        ]
      },
      selectedData: []
    };
  },
  props: ["addVisible", "dialogType", "detailInfo", "clickId"],
  mixins: [base],
  computed: {
    dialogTitle() {
      return this.dialogType === 1
        ? "新增"
        : this.dialogType === 2
        ? "编辑"
        : "详情";
    },
    isDetail() {
      return this.dialogType === 3;
    },
    isEdit() {
      return this.dialogType === 2;
    }
  },
  watch: {
    addVisible: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.addForm && this.$refs.addForm.clearValidate();
            this.$refs.tableForm && this.$refs.tableForm.clearValidate();
          });
          await this.loadParamOptions();
          this.initData();
        }
      }
    }
  },
  methods: {
    async loadParamOptions() {
      try {
        let res = await findDownList(["materialDeviceParam"]);
        this.paramOptions = this.getFreezeResponse(res, {
          path: "data.materialDeviceParam",
          defaultVal: []
        });
      } catch (error) {
        printError(error);
      }
    },
    initData() {
      this.resetForm();
      if (this.isEdit || this.isDetail) {
        this.fillForm(this.detailInfo);
      }
    },
    fillForm(detailInfo = {}) {
      this.addForm.materialNo = detailInfo.materialNo || "";
      this.addForm.materialName = detailInfo.materialName || "";
      this.tableForm.tableData = (detailInfo.paramList || []).map(item => ({
        materialDeviceParamId: item.materialDeviceParamId || "",
        deviceParam: item.deviceParam || "",
        deviceParamName: item.deviceParamName || "",
        deviceParamDetail: item.deviceParamDetail || ""
      }));
    },
    handleMaterialChange(val, node) {
      this.addForm.materialName = node ? node.label : "";
    },
    handleParamChange(row) {
      let target = (this.paramOptions || []).find(
        item => item.codeId === row.deviceParam
      ) || {};
      row.deviceParam = target.codeId || "";
      row.deviceParamName = target.codeName || "";
      row.deviceParamDetail = target.codeValue || "";
    },
    handleAddParam() {
      this.tableForm.tableData.push({
        materialDeviceParamId: "",
        deviceParam: "",
        deviceParamName: "",
        deviceParamDetail: ""
      });
    },
    deleteParams() {
      if (!this.selectedData.length) {
        this.$message.warning("请勾选需要删除的数据");
        return;
      }
      this.tableForm.tableData = this.tableForm.tableData.filter(item => {
        return !this.selectedData.includes(item);
      });
      this.selectedData = [];
    },
    handleSelectionChange(columns) {
      this.selectedData = columns;
    },
    handleSubmit() {
      const p1 = new Promise(resolve => {
        this.$refs.addForm.validate(valid => {
          if (valid) resolve();
        });
      });
      const p2 = new Promise(resolve => {
        this.$refs.tableForm.validate(valid => {
          if (valid) resolve();
        });
      });
      if (!this.tableForm.tableData.length) {
        this.$message.warning("请新增下发参数");
        return;
      }
      Promise.all([p1, p2]).then(() => {
        this.saveMaterialReq();
      });
    },
    async saveMaterialReq() {
      try {
        this.editDialogLoading = true;
        let res = await saveMaterialDeviceParam({
          materialNo: this.addForm.materialNo,
          paramList: this.tableForm.tableData.map(item => ({
            materialDeviceParamId: item.materialDeviceParamId || "",
            deviceParam: item.deviceParam || ""
          }))
        });
        if (res.code === "OK") {
          this.$message.success(this.dialogType === 1 ? "新增成功" : "编辑成功");
          this.$emit("refreshData");
          this.closeDialog();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.editDialogLoading = false;
      }
    },
    resetForm() {
      this.addForm = {
        materialNo: "",
        materialName: ""
      };
      this.tableForm.tableData = [];
    },
    closeDialog() {
      this.resetForm();
      this.$refs.addForm && this.$refs.addForm.resetFields();
      this.$refs.tableForm && this.$refs.tableForm.clearValidate();
      this.selectedData = [];
      this.$emit("update:addVisible", false);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/utils.scss";
@import "@/assets/styles/variables.scss";
/deep/.custom-dialog {
  .el-dialog__body {
    padding: 15px 20px;
    box-sizing: border-box;

    .el-form {
      .el-table {
        .el-form-item {
          margin-bottom: 12px;
          .el-input {
            width: 180px;
          }
        }
      }
    }
    .dialogTitle {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 100%;
      justify-content: flex-start;
      .line {
        width: 4px;
        height: 25px;
        background: #46bfea;
        margin-right: 5px;
      }
      .til {
        font-size: 16px;
        font-weight: 500;
        margin-right: 15px;
      }
      i {
        margin-right: 10px;
        font-size: 20px;
        color: #46bfea;
      }
    }
  }
}
</style>
